
/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
 if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

function $on(eventName, selector, func) {
  document.addEventListener(eventName, function (event) {
    // If the clicked element does not have the .click-me class, ignore it
    // if (!event.target.matches(eventName)) return;
    if (!event.target.closest(selector)) return;
  
    func(event, event.target);
  });
}


function $scrollTo(selector, duration=300) {
  if (typeof selector === 'string' || selector instanceof String) {
    el = document.querySelector(selector);
  }
  else {
      el = selector;
  }
  console.log('scroll to ', el.offsetTop);
  window.scroll({
    top: el.offsetTop - 150, 
    left: 0, 
    behavior: 'smooth' 
  });
  
//   document.querySelector(selector).scrollIntoView({ 
//     behavior: 'smooth' 
//   });
}

function $ready(func) {
  document.onreadystatechange = function () {
    if (document.readyState == "interactive") {
        // Initialize your application or run some code.
        if (func) func();
    }
  }
}